const all = {
  all: "All",
  point_channel: "Point collection channel",
  member_tier: "Member level",
  total_spend: "Remaining points",
  more_spending: "Accumulate additional amount",
  marketplace_channel: "Connection channel",
  placeholder_marketplace_select: "Please select an order channel",
  placeholder_marketplace_select_2: "Please select a store",
  status: "Status",
  connect_status: "Connection complete",
  connect_status_error: "",
  btn_connect_market: "Add connection channel",
  btn_connect_success_market: "Connection complete",
  btn_disconnect_market: "Remove connection",
  btn_connect: "Connect",
  redeem_quantity: "Number of products redeemed",
  point_used: "Number of points used",
  expired: "Expired",
  expired_date: "Expiration date",
  member_expired_date: "Membership expiration date",
  point_total: "Your accumulated points",
  currency_unit: "points",
  note: "Note ***",
  note_market: "For connecting various channels",
  note_market_1:
    "For the first channel connection, you can connect 1 hour after confirming receipt of the product",
  note_market_2:
    "For subsequent times, order information will be added automatically within 1 hour after confirming receipt of the product",
  history: "Usage history",
  see_detail: "Details",
  description: "Details",
  redeem_date: "Can be redeemed until",
  use: "Use",
  profile_general: "MY INFORMATION",
  profile_address: "Address information",
  profile_additional: "Additional information",
  policy: "Privacy Policy",
  pdpa: "Manage personal information",
  term: "Terms and Conditions",
  billing: "Tax invoice address",
  shipping: "Shipping address",
  contact: "Contact person",
  add_billing: "Add tax invoice address",
  add_shipping: "Add shipping address",
  add_contact: "Add a contact",
  info_billing: "Tax invoice address information",
  info_shipping: "Shipping address information",
  info_contact: "Contact information",
  use_as_profile: "Use personal address",
  add: "Add",
  ext: "Continue",
  default: "Default",
  save: "Save Changes",
  confirm: "Confirm",
  branch_select_coupon: "Please select a branch",
  confirm_used: "Confirm use",
  already_used: "Already used",
  cancel: "CANCEL",
  close_window: "Close this window",
  mission_detail: "Mission details",
  mission_reward: "Gift set",
  get_reward: "Join",
  spending: "Accumulate purchase amount",
  stamp_collect: "Must have at least",
  stamp: "right",
  finish: "Finish",
  process: "In progress",
  privilege_receive_success: " ",
  privilege_code: "Special privilege code",
  privilege_code_error: "Invalid privilege code",
  privilege: "Benefits",
  placeholder: "Please fill in",
  use_coupon: "REDEEM IN STORE",
  coupon_code: "VOUCHER CODE",
  coupon_note: "",
  point_receive_total: "Points received / used",
  list: "List",
  profile: "Personal information",
  logout: "LOG OUT",
  member_tier_expired: "The system will adjust your membership level within",
  to_upgrade: "to upgrade",
  maintain: "to maintain status",
  next_tier: "next level",
  keep_current: "to maintain status",
  qr_count_time: "QR Code will expire in",
  total_spend_unit: "Accumulated points (points)",
  count_purchase_times: "Purchases (times)",
  count_purchase_unit: "Purchases (baht)",
  collect_point: "Accumulated points",
  total_collect_point: "Accumulated points",
  back: "Back",
  need_point: "Need more points",
  complate_profile: "Profile completeness",
  edit_profile: "Edit personal information",
  edit: "EDIT",
  firstname: "First name",
  lastname: "Last name",
  email: "Email",
  telephone: "Phone Number",
  birthday: "Birthday",
  point_expired: "Points expiring soon",
  success: "Success",
  confirm_header_text: "Do you want to continue with this action?",
  amount: "Amount",
  default_input_validate: "is required",
  redeem_text: "Gift",
  search: "Search",
  clear_filter: "Clear filter",
  remain: "Remaining",
  piece: "piece",
  no_detail: "No details",
  no_data: "No data found",
  number_times: "Number of rights",
  loading: "Please wait a moment",
  create_date: "Created date",
  way_to_earn: "Add a channel to collect points",
  free_point: "Get free accumulated points",
  purchase_channel: "Order channel",
  market_name: "Store name",
  order_no: "Order number (Order No.)",
  track_id: "Tracking number (Tracking ID.)",
  info_manage: "Manage personal information",
  additional_note: "Specify additional reason",
  request_information: "Request access to information",
  request_transfer_information: "Request to transfer information",
  request_deny_information: "Request to withdraw consent",
  request_edit_information: "Request to edit information",
  request_suspend_information:
    "Request to suspend and object to use of information",
  request_delete_information: "Request to delete information",
  login_title: "Create Profile / Sign In",
  register_title: "CREATE PROFILE / SIGN IN",
  telephone_title: "Telephone Title",
  telephone_subtitle: "",
  redeem_exceed_quota_per_customer_title:
    "You have already redeemed the maximum allowed",
  redeem_exceed_quota_title: "Reward is out of stock",
  redeem_button: "Redeem",
  redeem_remark:
    "You can receive the gift set only at the Clarins counter at the branch you selected, between XX February - XX March",
  mission_title: "Membership Activity",
  upcomming_text: "Upcoming Reward",
  upload_receipt_loading:
    "The system is verifying your submission. Thank you for using our service. You can check the status again later.",
  header_shipping_address_form: "",
  footer_shipping_address_form: "",
  header_billing_address_form: "",
  footer_billing_address_form: "",
  header_contact_address_form: "",
  footer_contact_address_form: "",
  header_register_form: "",
  footer_register_form: "",
  delete: "Delete",
  shipping_methods: "Shipping method",
  social_media: "Social media",
  your_telephone: "Your phone number",
  main_telephone: "Phone number (primary)",
  optional_telephone: "Secondary phone number",
  your_spending: "Your spending",
  close: "Close",
  default_select_validate: "Please select an option",
  filter: "Filter",
  choose: "Selecting",
  confirm_logout: "Do you want to logout?",
  next_page: "CONTINUE",
  send_otp_message: "Please fill in the verification code sent to",
  fill_otp: "",
  change_telephone: "Change Phone Number",
  skip: "Skip",
  earn_channel: "Point collection channel",
  privilege_for: "Benefits for",
  setting: "Settings",
  change_language: "Change language",
  language: "Language",
  date: "Current time",
  wait_otp: "You will receive the OTP code in",
  send_otp: "Resend",
  register: "Register",
  consent_policy_message:
    "By signing up for this membership, I declare that I have read and agreed to COS Thailand's {{policy}} and {{term}}&nbsp;",
  consent_term_message:
    "I consent to COS Thailand sharing my personal data with its related group of companies, for the purpose of direct marketing by them for other offerings in Thailand, according to {{policy}} and {{term}}&nbsp;",
  your_receipt: "Your receipt",
  history_use: "History",
  per_day: "per day",
  limit_user_receipt: "You have reached today's submission limit",
  no_receipt_upload: "No receipt yet, please submit a receipt",
  send_receipt: "Submit receipt",
  confirm_send_receipt: "Confirm receipt submission?",
  confirm_message_send_receipt:
    "Confirm receipt submission. Please verify accuracy before submitting. The system will verify and confirm rights within 24 hours.",
  receipt_campaign_date: "Sorry, this campaign is available on",
  receipt_campaign_expired: "Sorry, this campaign has expired",
  receipt_campaign_not_found: "Sorry, no participating campaign found",
  go_to_history: "Go to history page",
  receipt_upload_success: "Receipt uploaded successfully",
  receipt_unit: "items",
  confirm_delete_receipt: "Confirm receipt deletion?",
  confirm_message_delete_receipt:
    "Confirm receipt deletion. Please verify accuracy before deleting.",
  validate_input_min_length: "Invalid Phone Number",
  validate_input_max_length: "Please do not enter more than",
  validate_input_number: "Please enter numbers only",
  validate_english_only: "Please enter letters only",
  validate_english_num_only: "Please enter English letters and numbers only",
  validate_id_card: "Please enter a valid ID card format",
  validate_email: "Please enter a valid email (e.g. email@example.com)",
  character: "",
  news: "News",
  spending_history: "Point history",
  branch_spending: "Your branch accumulated points",
  current_total_spend: "Current accumulated points",
  all_accumulate: "Total accumulated points",
  send_check: "Submit for review",
  invoice_no: "Receipt number",
  collect_point_all: "Total accumulated points",
  telephone_change_subtitle: "",
  receipt_cancel_invoice: "Cancel this item",
  receipt_max_error_message_1:
    "Because too many receipts could not be verified, exceeding",
  receipt_max_error_message_2:
    "times per day\\n Please try again tomorrow or contact staff",
  receipt_max_upload_message: "You have reached today's submission limit",
  error_message: "An error occurred!",
  upload_image_text: "Add image",
  day: "DAY",
  month: "MONTH",
  year: "YEAR",
  year_ad: "AD",
  year_be: "BE",
  upgrade_unit: "baht",
  allow_login_error_message: "Not Allow New User for Registering.",
  email_login_message: "Sign in with email",
  telephone_login_message: "Sign in with phone number",
  send_email_otp_message: "Enter the code we sent via email to ",
  change_email: "Change email",
  change_email_title: "Change email",
  email_change_subtitle: "",
  email_subtitle: "",
  email_title: "CREATE PROFILE / SIGN IN",
  fill_otp_email_login:
    "Please enter the OTP code received into the email field",
  wait_otp_email_login: "You will receive the OTP code in ",
  send_otp_email_login: "Resend Otp Email",
  consent_policy_message_email_login_pdpa_email:
    "I consent to PT GTiga Kap Indonesia sharing my personal data (according to PT GTiga Kap Indonesia's {{policy}}) with its related group of companies, which includes the necessary transfer of my personal data out of Indonesia, for the purpose of direct marketing by them for other offerings in Indonesia or membership program (if any).",
  consent_term_message_email_login_policy_email:
    "I consent to the processing of my personal data (according to, and for the purposes set out in, PT GTiga Kap Indonesia's {{policy}}), which includes the necessary transfer of my personal data out of Indonesia (1) to a country where PT GTiga Kap Indonesia stores my personal data, and (2) to Golden Goose S.p.A. whose privacy policy can be found at https://www.goldengoose.com/ww/en/privacy.html.",
  policy_email: "Privacy policy",
  term_email: "Term Email",
  win_reward: "Congratulations, you received a reward",
  received_prize: "Received a reward",
  received_prize_description:
    "Your luck is still good. Tap to view the reward and continue",
  not_received_prize: "You did not receive a reward",
  view_random_reward_prize: "View reward",
  view_mission_prize: "Tap to view reward",
  open_box: "Open your reward box",
  open_all_box: "Open all",
  send_more_code: "Send more codes",
  random_reward_title: "Scan to win with",
  mission_random_reward_title: "Scan to win with Mission Dcrm",
  random_reward_description:
    'If your luck is ready, tap "Open reward box" to try your luck',
  mission_random_reward_description:
    'If your luck is ready, tap "Open reward box" to try your luck',
  back_mission_prize: "Back to Mission 1 home",
  back_random_reward_prize: "Back to home",
  receive_reward: "Received",
  not_receive_reward: "Not received",
  close_edit: "CLOSE EDIT",
  minimal_transaction_tab_title: "TRANSACTION HISTORY",
  minimal_profile_tab_title: "MY PROFILE",
  transaction_empty: "You haven't purchased any products yet.",
  transaction_description:
    "We're currently unable to display some detailed order history due to recent updates. Thank you for patience and understanding.",
  transaction_title: "IN-STORE PURCHASE",
  text_send_otp: "Send OTP",
  continue: "Continue",
  member_qr_title: " MEMBERSHIP BARCODE",
  otp_input_title: "Email OTP - 6 Digits",
  purchase_note: "Color/Size",
  purchase_id: "Purchase ID",
  purchase_date: "DATE",
  purchase_store: "STORE",
  member_id: "MEMBER ID",
  transaction_header: "TRANSACTION HISTORY",
  passport_description: "Passport Description",
  passport_title: "Passport Title",
  passport_verify_title: "Passport Verify Title",
  passport_verify_description: "Passport Verify Description",
  verification_type_title: "Verifying Your Identity",
  verification_type_description:
    "Choose a verification method by specifying your ID card number or passport number",
  card_title: "ID Card Title",
  card_verify_title: "Verification Type",
  card_description: "Select Verification Type",
  card_verify_description: "Card Verify Description",
  profile_coupon: "My Coupons",
  coupon_detail_title: "Coupon Details",
  coupon_note_title: "REDEEM VOUCHER",
  voucher_active: "VOUCHER ACTIVE",
  save_change: "Save Changes",
  cancel_change: "Cancel Changes",
  register_success_message: "Your information has been received successfully",
  coupon_is_already_used: "Coupon has been used",
  validate_phone_format: "Invalid phone number format",
  telephone_example: "08XXXXXX",
  example: "example",
  email_example: "example@mail.com",
  welcome: "HELLO",
  currency_sign: "SGD",
  email_duplicate: "Cannot use this email address",
  birthday_at_least:
    "You have to be at least {{year}} years old to become a member",
  member_benefit: " ",
  consent_term_intro: "test term intro",
  consent_policy_intro: "test policy intro",
  consent_email_policy_intro:
    "PT GTiga Kap Indonesia (authorised retailer of the Golden Goose brand in Indonesia) is Golden Goose S.p.A.'s appointed data processor following a data processor appointment. \\n I understand and agree that in order to receive any services from Golden Goose S.p.A. or PT GTiga Kap Indonesia: ",
  consent_email_term_intro: "I am interested in other offerings: ",
  home: "Home",
  right_unit: "rights",
  news_and_promotion: "News and promotions",
  credit_balance: "Credit balance",
  package_balance: "Package balance",
  voucher_balance: "Voucher balance",
  spa_wallet: "Spa Wallet",
  spa_wallet_expiring_soon: "Expiring soon",
  spa_wallet_vouchers: "Vouchers",
  spa_wallet_packages: "Packages",
  spa_wallet_remaining_quantity: "Remaining quantity",
  spa_wallet_purchase_date: "Purchase date",
  spa_wallet_expiration_date: "Expiration date",
  spa_wallet_used: "USED",
  spa_wallet_tab_available: "Available",
  spa_wallet_tab_unavailable: "Unavailable",
  spa_wallet_not_use_service_yet: "Service not used yet",
  privilege_channel_online: "Online",
  privilege_channel_store: "In-store",
  privilege_expiring_soon: "Expiring soon",
  privilege_expiration_label: "Expires",
  mission_progress_summary: "Completed / Total",
  mission_complete_to_receive_reward:
    "Complete the mission to receive the reward",
  mission_action: "Do mission",
  credit_top_up_history: "Credit top-up history",
  credit_top_up: "Top up credit",
  credit_usage: "Use credit",
  credit_unit: "credit",
  try_again_later: "An error occurred. Please try again later",
  coupon_countdown_warning:
    "This code is valid for {{minute}} minutes after confirming the right.\nIf not used within the specified time, it will be considered forfeited.\nThe company will not reissue the code in any case.",
  qr_code: "QR Code",
  barcode: "Barcode",
  consent_receive_news:
    "I would like to receive privileges and promotions, including news from {{brand}}, as specified in",

  consent_personal_data:
    "I expressly consent to the collection, use, and disclosure of my personal data, as detailed in",
  month_january: "January",
  month_february: "February",
  month_march: "March",
  month_april: "April",
  month_may: "May",
  month_june: "June",
  month_july: "July",
  month_august: "August",
  month_september: "September",
  month_october: "October",
  month_november: "November",
  month_december: "December",
  reward_redeem_success: "Reward redeemed successfully",
  reward_redeem_now: "Redeem now",
  send_now: "Send now",
  next: "Next",
  friend_invite_link: "Friend invite link",
  link: "L I N K",
  copy_link: "Copy Link.",
  invited_friends: "Invited friends",
  already_member: "Sorry, you are already a member",
  receive_gift: "Receive gift",
  package: "Package",
  package_name: "Package name",
  available_usage_count: "Available usage count",
  generic_date: "Date",
  sort_by: "Sort by",
  sort_received_newest: "Date received: Newest → Oldest",
  sort_received_oldest: "Date received: Oldest → Newest",
  sort_expired_latest: "Expiration: Latest → Soonest",
  sort_expired_soonest: "Expiration: Soonest → Latest",
  register_member_title: "Register",
  error: "An error occurred",
  profile_update_error: "An error occurred, unable to edit information",
  review_information: "Review information",
  email_already_registered: "This email is already registered",
  telephone_already_registered: "This phone number is already in the system",
  company_information: "Company information",
  news_detail: "News details",
  privilege_detail: "Privilege details",
  see_all: "See all",
  profile_menu_personal_info: "Personal information",
  profile_menu_spa_credit: "My SPA credit",
  profile_menu_courses: "My courses",
  profile_menu_vouchers: "My vouchers",
  profile_menu_benefits: "My benefits",
  profile_menu_service_history: "Service history",
  profile_menu_purchase_history: "My purchases",
  profile_menu_reward_history: "Reward redemption history",
  profile_menu_mission: "My missions",
  profile_menu_friend_invite: "Refer a friend",
  show_details: "Show details",
  hide_details: "Hide details",
  filter_last_1_month: "Last 1 month",
  filter_last_3_month: "Last 3 months",
  filter_last_6_month: "Last 6 months",
  remark_qr: "Show the barcode to staff to scan every time you use the service",
  verify_code_button: "Request verification code",
  verify_code_title: "Verification code",
  verify_member_code: "Member code",
  footer_qr_title: "QR",
  please_fill_data: "Please fill in the information",
  grand_total: "Total accumulated",
  reward_delivery_address_title: "Shipping address details",
  reward_delivery_notice:
    "The reward will be delivered by post. Please review / complete your information.",
  reward_delivery_profile_note:
    "The delivery address uses your personal address. Any update will become the latest information.",
  reward_home_address: "Address",
  reward_province: "Province",
  reward_district: "District",
  reward_subdistrict: "Subdistrict",
  reward_zip_code: "Postal code",
  reward_confirm_redeem_title: "Confirm reward redemption",

  reward_current_point: "Current points",
  reward_required_point: "Points required",
  reward_remaining_point: "Remaining points",
  reward_confirm_with_points: "Confirm ({{points}} points)",
  reward_success_received_title: "Congratulations, you received a reward",
  reward_pickup_message:
    "The reward will be delivered by post. Please review / complete your information.",
  reward_pickup_success_message:
    "Thank you for redeeming this reward. Please wait for delivery to your registered address.",
  reward_back_home: "Back to home",
  reward_go_to_coupon: "Go to coupon page",
  reward_coupon_used: "Coupon already used",
  reward_insufficient_point: "Insufficient points",
  reward_cannot_redeem: "Cannot redeem reward",
  reward_redeem_default_button: "Redeem gift set",
  reward_unregistered_suffix: "(You are not registered)",
  reward_condition_title: "Condition",
  reward_condition_fallback: "You do not meet the reward condition",
  footer_spa_title: "SPA",
  all_privilege: "All privileges",
  reward_list: "Gifts",
  section_load_error: "Unable to load data. Please try again",
  retry: "Retry",
  reward_redeem_now_title: "",
  vv_bottom_navigation_label: "Vision Venture main navigation",
  vv_retail: "VV Retail",

  vv_retail_page_title: "Connect brands in VV Retail",
  vv_retail_card_title: "Connect brands in VV Retail",
  vv_retail_click_to_connect: "Click to connect",
  profile_menu_marketplace: "Connect Marketplace",
  profile_menu_settings: "Settings",
  switch_account: "Switch account",
  select_profile_title: "Select a profile",
  select_profile_hint:
    "To delete a profile, please contact customer service through the @bettervisionth LINE Official Account",
  create_new_profile: "Create a new profile",
  vv_delete_profile_confirm_title: "Warning",
  vv_delete_profile_confirm_message:
    "Deleted profile information cannot be recovered",
  vv_delete_profile_confirm_button: "Confirm profile deletion",
  vv_register_details_title: "Please provide the correct information",
  vv_birthday_label: "Day / Month / Year of birth",
  vv_birthday_day_title: "Day of birth",
  vv_birthday_month_title: "Month of birth",
  vv_birthday_year_title_be: "Year of birth (B.E.)",
  vv_birthday_year_title_ad: "Year of birth (A.D.)",
  vv_birthday_day_placeholder: "Day",
  vv_birthday_month_placeholder: "Month",
  vv_birthday_year_placeholder: "Year",
  vv_birthday_mismatch_error:
    "The birthday does not match the member profile. Please try again.",
  vv_register_cancel: "Cancel",
  vv_language_confirm: "Confirm",
  vv_language_cancel: "Cancel",
  vv_register_complete_title: "Registration complete",
  vv_register_complete_message: "Your information has been saved successfully",
  vv_register_continue: "Continue",

  discover: "discover",
  redeem: "Redeem points"
};

const standardV2 = {};

const pointToBaht = {
  point_to_baht_select_amount: "Select the amount to redeem",
  point_to_baht_discount_received: "Available discount",
  point_to_baht_expires_in: "expires in",
  point_to_baht_days: "({{days}} days)",
  point_to_baht_no_expiry_data: "No expiring point information",
  point_to_baht_receipt_total: "Receipt total",
  point_to_baht_discount: "Discount",
  point_to_baht_receipt_required: "Enter the receipt total",
  point_to_baht_points_required: "Enter the points to redeem",
  point_to_baht_points_exceed: "Points exceed your current balance",
  point_to_baht_discount_exceed: "Discount cannot exceed the receipt total",
  point_to_baht_points_minimum: "The minimum redemption is {{points}} points",
  point_to_baht_receipt_limit_exceed:
    "You can redeem up to {{points}} points ({{percent}}% of the receipt total)",
  point_to_baht_coupon_title: "Cash coupon worth {{amount}} baht",
  point_to_baht_coupon_received: "Your coupon is ready to use",
  point_to_baht_back_to_points: "Back to my points"
};

const eyeRecord = {
  eye_record_page_title: "Eye prescription history",
  eye_record_lens_type_label: "Lens type",
  eye_record_glasses_tab: "Glasses",
  eye_record_contact_lens_tab: "Contact lenses",
  eye_record_metric_label: "Prescription measurement",
  eye_record_sph_label: "SPH",
  eye_record_cyl_label: "CYL",
  eye_record_add_label: "ADD",
  eye_record_sph_description: "Nearsighted (-) or farsighted (+) power",
  eye_record_cyl_description:
    "Cylinder power caused by the curvature of the cornea",
  eye_record_add_description:
    "Additional near-vision power for progressive lenses",
  eye_record_right_eye: "Right (R)",
  eye_record_left_eye: "Left (L)",
  eye_record_home_title: "Latest prescription",
  eye_record_home_history_link: "View prescription history",
  eye_record_home_empty: "You don't have any prescription history yet",
  eye_record_recommendation_title: "Additional recommendations",
  eye_record_recommendation_one:
    "These preliminary values should not be used to make glasses immediately. Consult an eye-care professional for an assessment with the actual frame.",
  eye_record_recommendation_two:
    "Have your prescription checked annually or as advised by your eye-care professional.",
  eye_record_recommendation_three:
    "If your prescription changes, arrange a check every 3-6 months."
};

const standardV20 = {
  remark_qr: "Show the barcode to staff to scan every time you use the service",
  verify_code_button: "Request verification code",
  verify_code_title: "Verification code",
  verify_member_code: "Member code",
  footer_qr_title: "QR",
  please_fill_data: "Please fill in the information",
  grand_total: "Total accumulated",
  reward_delivery_address_title: "Shipping address details",
  reward_delivery_notice:
    "The reward will be delivered by post. Please review / complete your information.",
  reward_delivery_profile_note:
    "The delivery address uses your personal address. Any update will become the latest information.",
  reward_home_address: "Address",
  reward_province: "Province",
  reward_district: "District",
  reward_subdistrict: "Subdistrict",
  reward_zip_code: "Postal code",
  reward_confirm_redeem_title: "Confirm reward redemption",

  reward_current_point: "Current points",
  reward_required_point: "Points required",
  reward_remaining_point: "Remaining points",
  reward_confirm_with_points: "Confirm ({{points}} points)",
  reward_success_received_title: "Congratulations, you received a reward",
  reward_pickup_message:
    "The reward will be delivered by post. Please review / complete your information.",
  reward_pickup_success_message:
    "Thank you for redeeming this reward. Please wait for delivery to your registered address.",
  reward_back_home: "Back to home",
  reward_go_to_coupon: "Go to coupon page",
  reward_coupon_used: "Coupon already used",
  reward_insufficient_point: "Insufficient points",
  reward_cannot_redeem: "Cannot redeem reward",
  reward_redeem_default_button: "Redeem gift set",
  reward_unregistered_suffix: "(You are not registered)",
  reward_condition_title: "Condition",
  reward_condition_fallback: "You do not meet the reward condition",
  footer_spa_title: "SPA",
  all_privilege: "All privileges",
  reward_list: "Gifts",
  section_load_error: "Unable to load data. Please try again",
  retry: "Retry",
  reward_redeem_now_title: "",

  discover: "discover",
  redeem: "Redeem points"
};

const input = {};
const en = {
  ...input,
  ...all,
  ...standardV2,
  ...standardV20,
  ...pointToBaht,
  ...eyeRecord
};
export default en;
